/**
 * This method normalizes object containing list of virtualEvents
 * It returns object containing 2 keys
 * 1st is byKey. This is an object of sessionKey and virtualEvent
 * 2nd is allKeys. This is an array containing all virtualEventKeys
 *
 * @param entitiesMap
 * @returns {{byKey, allKeys}}
 */

import { denormalize, normalize, schema } from 'normalizr';
const virtualEvent = new schema.Entity('virtualEvents', {}, { idAttribute: 'eventKey' });
const virtualEventsSchema = { virtualEvents: [virtualEvent] };

export function normalizeVirtualEvents(virtualEventsList = []) {
  if (virtualEventsList.length === 0) {
    return {
      byKey: {},
      allKeys: []
    };
  }
  const { result, entities } = normalize({ virtualEvents: virtualEventsList }, virtualEventsSchema);
  return {
    byKey: entities.virtualEvents,
    allKeys: result.virtualEvents
  };
}

/**
 * This method de normalizes virtualEventsMap for given virtualEventKeys
 *
 * @param virtualEventKeys
 * @param virtualEventsMap
 * @returns [virtualEvents]
 */
export function denormalizeVirtualEvents(virtualEventKeys, virtualEventsMap) {
  if (virtualEventKeys === null || virtualEventKeys.length === 0) {
    return [];
  }
  const deNormalizedData = denormalize({ virtualEvents: virtualEventKeys }, virtualEventsSchema, {
    virtualEvents: virtualEventsMap
  });
  return deNormalizedData.virtualEvents;
}



// WEBPACK FOOTER //
// ./src/Reducks/VirtualEvents/VirtualEventsUtils.js